module.exports = __webpack_public_path__ + "media/images/dashboard_icons/user-4ab35a5232d17ae3501a60a8aba1daa4.svg";